
import { StrapiLocale } from '@nuxtjs/strapi/dist/runtime/types';
import { Tag } from '../models/Tag';


export const useTags = async (locale: string) => {
    const { find } = useStrapi()
    return await useAsyncData('tags', () => find<Tag>('tags', { locale: locale as StrapiLocale }));
}